<div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="8px">
  <button fxLayoutAlign="center center" class="gig-button icon" [disabled]="disabledLeft" (click)="previousClick()">
    <mat-icon class="control-icon left" svgIcon="expand-left"></mat-icon>
  </button>

  <button fxLayoutAlign="center center" class="gig-button icon" [disabled]="disabledRight" (click)="nextClick()">
    <mat-icon class="control-icon right" svgIcon="expand-left"></mat-icon>
  </button>
</div>
